import { FieldProps } from 'formik';
import * as React from 'react';
import ErrorTextField from './ErrorTextField';

interface FormFieldProps extends FieldProps {
	required?: boolean;
}

const options = [
	'Family or Friends',
	'LinkedIn',
	'Indeed',
	'Craigslist',
	'GitHub',
	'Referral',
	'Other',
];

const HearAboutMk: React.StatelessComponent<FormFieldProps> = function (props) {
	const {
		form: { errors, touched },
		field,
		required,
	} = props;
	const name = field.name;

	return <ErrorTextField
		label='How did you hear about MK Decision?'
		required={required}
		errorMessage={touched[name] ? errors[name] as string : undefined}
		options={options}
		{...field}
	/>;
};

export default HearAboutMk;
